import { exposeExperimentsToNewRelic } from '@data/queries/initialData/exposeExperimentsToNewRelic'
import { schema } from '@data/queries/initialData/schema'
import { InitialQueryData } from '@data/queries/types'
import { extractDataFromHtml } from '@util/extractDataFromHtml'
import { logError } from '@util/logger'

const initialQueryData = extractDataFromHtml('initialQueryData', schema)

if (initialQueryData) {
    exposeExperimentsToNewRelic(initialQueryData)
}

/**
 * Returns a particular piece of data that was embedded in the HTML by Symfony
 *
 * @param mapper Yup schema to validate the data and provide type safety
 */
export function getInitialQueryData<T>(
    propName: keyof InitialQueryData | undefined,
    mapper: (json: Json) => T
): T | undefined {
    if (!initialQueryData || !propName || !(propName in initialQueryData)) {
        // There's simply no Symfony data in this case
        return
    }

    const data = initialQueryData[propName]

    if (!data) {
        return
    }

    try {
        return mapper(data)
    } catch (e) {
        logError(
            `Could not parse JSON for initial query data for “${propName}”${e instanceof Error ? `: ${e.message}` : ''}`
        )
    }

    return
}
